<template>
  <!-- 实名认证 合伙人 -->
  <div class="">
    <template v-if="partnerType === 1">
      <!--<p class="real-name-title">公司营业执照</p>-->
      <div class="row-space">
        <el-upload
          key="businessLicense"
          class="single-file"
          style="margin: 0 auto;width: 176px;"
          action=""
          drag
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
          :http-request="res=>handleRequest(res,3)"
        >
          <div class="upload-inner-box" v-if="businessLicenseUrl">
            <div class="tools-row">
              <div class="tools-item" @click.stop="viewBigImage(businessLicenseUrl)">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
            <img :src="businessLicenseUrl" class="single-file-image">
          </div>
          <div class="single-file-icon" v-else>
            <img :src="images.iconUpload" alt="" class="icon-image"/>
            <p class="description">点击上传公司营业执照</p>
          </div>
        </el-upload>
      </div>
    </template>
    <template v-else-if="partnerType === 2">
      <p class="real-name-title">个人身份证</p>
      <div class="identity-card-row row-space">
        <el-upload
          key="identityCardFront"
          class="single-uploader"
          action=""
          drag
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
          :http-request="res=>handleRequest(res,1)"
        >
          <div class="upload-inner-box" v-if="identityCardFrontUrl">
            <div class="tools-row">
              <div class="tools-item" @click.stop="viewBigImage(identityCardFrontUrl)">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
            <img :src="identityCardFrontUrl" class="single-uploader-image">
          </div>
          <template v-else>
            <!--<i class="el-icon-plus single-uploader-icon"></i>-->
            <div class="upload-inner-box" :style="`background-image: url(${images.bgBefore})`"/>
          </template>

        </el-upload>
        <el-upload
          key="identityCardBack"
          style="margin-left: 24px;"
          class="single-uploader"
          action=""
          drag
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
          :http-request="res=>handleRequest(res,2)"
        >
          <div class="upload-inner-box" v-if="identityCardBackUrl">
            <div class="tools-row">
              <div class="tools-item" @click.stop="viewBigImage(identityCardBackUrl)">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
            <img :src="identityCardBackUrl" class="single-uploader-image">
          </div>
          <template v-else>
            <!--<i class="el-icon-plus single-uploader-icon"></i>-->
            <div class="upload-inner-box" :style="`background-image: url(${images.bgAfter})`"/>
          </template>
        </el-upload>
      </div>

      <p class="real-name-title">从业简历认证</p>
      <div class="row-space">
        <el-upload
          key="resume"
          ref="resume"
          class="single-file"
          action=""
          drag
          show-file-list
          :limit="1"
          :before-upload="handleBeforeUpload2"
          :http-request="handleRequest2"
          :on-exceed="handleExceed"
          :on-preview="handlePreview"
        >
          <div class="single-file-icon">
            <img :src="images.iconUpload" alt="" class="icon-image"/>
            <p class="description">点击上传简历认证，不限格式</p>
          </div>
        </el-upload>
      </div>
    </template>

    <div class="text-center">
      <el-button
        style="width: 176px;"
        type="primary"
        :loading="submitLoading"
        @click="clickSubmit">提交</el-button>
    </div>

    <el-dialog
      :visible.sync="visibleViewImage"
      :close-on-press-escape="false"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      @closed="viewImageUrl = ''"

    >
      <img width="100%" :src="viewImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {
  downLoadFileUrl,
  getUrlAfterUploadFile,
  getUrlAfterUploadImg,
  uploadImageBefore
} from "@/assets/js/utils.upload";
import {isObject} from "my-tools-kit";
import {mapGetters} from "vuex";
import { sendCustomerOperationRecord } from "@/assets/js/utils";

export default {
  name: "realNameAuthenticationPartner",
  props:{
    // 类型 1：销售代理认证 2：分销大使认证，3：省代 4：产业带加盟商 5：专线/分段供应商入驻  6:城市合伙人
    type:{
      type:[Number,String],
      default:6,
    },
    // 合伙人认证类型 1:公司 2:个人
    partnerType:{
      type:[Number,String],
      default:2,
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      ossPath,
      images:{
        // 身份证背景图（正面）
        bgBefore: ossPath + "/pages/realNameAuthentication/bg_identity_card_front.png",
        // 身份证背景图（反面）
        bgAfter: ossPath + "/pages/realNameAuthentication/bg_identity_card_back.png",
        iconUpload: ossPath + "/pages/realNameAuthentication/icon_upload.png",
      },
      // 身份证（正面）上传后返回的路径
      identityCardFrontUrl:"",
      // 身份证（正面）上传文件的其他参数
      identityCardFrontOtherParams:null,
      // 身份证（反面）上传后返回的路径
      identityCardBackUrl:"",
      // 身份证（反面）上传文件的其他参数
      identityCardBackOtherParams:null,
      // 从业简历 上传后返回的路径
      resumeUrl:"",
      // 从业简历 上传文件的其他参数
      resumeOtherParams:null,
      // 公司营业执照 上传后返回的路径
      businessLicenseUrl:"",
      // 公司营业执照 上传文件的其他参数
      businessLicenseOtherParams:null,
      // 提交状态
      submitLoading:false,
      // 查看图片大图
      visibleViewImage:false,
      viewImageUrl:"",
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["realNameType"])
  },
  methods:{
    /**
     * 上传图片前
     * @param file
     * @returns {boolean}
     */
    handleBeforeUpload(file){
      let result =  uploadImageBefore(file);
      return result;
    },
    /**
     * 自定义上传图片接口
     * @param res {object}  文件参数 { file, filename }
     * @param type  {number}  类型 1-身份证正面 2-身份证反面 3-公司营业执照
     */
    handleRequest(res,type){
      let { file, filename } = res;
      return getUrlAfterUploadImg(file)
        .then(res=>{
          this.$message.success("上传成功");
          let {fileName,fileSize,fileUrl} = res.data || {};
          if(type === 1){
            this.identityCardFrontUrl = fileUrl;
            this.identityCardFrontOtherParams = {
              fileName,
              fileSize,
              filePath:fileUrl,
              fileType:1,
            };
          }else if(type === 2){
            this.identityCardBackUrl = fileUrl;
            this.identityCardBackOtherParams = {
              fileName,
              fileSize,
              filePath:fileUrl,
              fileType:2,
            };
          }else{
            this.businessLicenseUrl = fileUrl;
            this.businessLicenseOtherParams = {
              fileName,
              fileSize,
              filePath:fileUrl,
              fileType:3,
            };
          }
        })
        // .catch(res=>{
        //   if(type === 1){
        //     this.identityCardFrontUrl = "";
        //   }else if(type === 2){
        //     this.identityCardBackUrl = "";
        //   }else{
        //     this.businessLicenseUrl = "";
        //   }
        //   return Promise.reject(res);
        // })
    },
    /**
     * 上传从业简历前
     * @param file
     */
    handleBeforeUpload2(file){
      console.log(file)
      return true;
    },
    /**
     * 上传从业简历
     * @param res {object}  文件参数 { file, filename }
     */
    handleRequest2(res){
      let { file, filename } = res;
      console.log(res)
      return getUrlAfterUploadFile(file)
        .then(res=>{
          this.$message.success("上传简历成功");
          let {fileName,fileSize,fileUrl} = res.data || {};
          this.resumeUrl = fileUrl;
          this.resumeOtherParams = {
            fileName,
            fileSize,
            filePath:fileUrl,
            fileType:3,
          };
        })
        // .catch(res=>{
          // this.$refs.resume.clearFiles();
          //   return Promise.reject(res);
        // })
    },
    /**
     * 从业简历 文件超出个数限制时的钩子
     * @param files
     * @param fileList
     */
    handleExceed(files, fileList){
      this.$message.error("从业简历最多上传一个文件，请先移除已上传文件后重试");
    },
    /**
     * 点击文件列表中已上传的文件时的钩子
     * @param file
     */
    handlePreview(file){
      // if(this.resumeUrl) window.open(this.resumeUrl);
      console.log(file)
      downLoadFileUrl(this.resumeUrl)
    },
    /**
     * 点击提交
     */
    clickSubmit(){
      if(this.partnerType === 2){
        if(!this.identityCardFrontUrl) return this.$message.error("请上传身份证(正面)");
        if(!this.identityCardBackUrl) return this.$message.error("请上传身份证(反面)");
        if(!this.resumeUrl) return this.$message.error("请上传从业简历");
      }else{
        if(!this.businessLicenseUrl) return this.$message.error("请上传公司营业执照");
      }
      sendCustomerOperationRecord('提交认证资料', '城市合伙人认证')
      let url = "/api/customer/cityPartnerRealNameAuthentication";
      let data = {
        // 认证类型：1 公司申请 2 个人申请
        authenticationType: this.partnerType,
        // 客户id
        customerid: this.$store.getters.customerId || "",
        // 上传的文件列表
        fileInfo:[
          // {
          //   //内容类型
          //   contentType:"",
          //   //文件名称
          //   fileName:"",
          //   //文件路径
          //   filePath:"",
          //   //文件大小
          //   fileSize:"",
          //   //文件类型：1 身份证正面 2 身份证背面 3 从业简历/营业执照
          //   fileType:1,
          // }
        ],
        remarks:"",
        //类型 1：销售代理认证 2：分销大使认证, 3：省代 4：产业带加盟商 5：专线/分段供应商入驻 6：城市合伙人
        type:this.type,
      };
      if (this.realNameType === 7) {
        data.fromTemporaryVisitor = 1
      }

      if(this.partnerType === 2){
        Object.assign(data,{
          fileInfo:[
            this.identityCardFrontOtherParams,
            this.identityCardBackOtherParams,
            this.resumeOtherParams,
          ],
        })
      }else{
        Object.assign(data,{
          fileInfo:[
            this.businessLicenseOtherParams,
          ],
        })
      }
      this.submitLoading = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          setTimeout(()=>this.submitLoading = false,1000);
          this.$message({
            message: "已提交相关资料，审核中",
            type: "success",
          });
          this.$emit("success");
        })
        .catch(res => {
          setTimeout(()=>this.submitLoading = false,1000);
          console.error(res);
          this.error(`提交：${res.message||"网络异常，请稍后再试"}`);
        })
    },
    /**
     * 重置认证数据
     */
    resetData(){
      if(this.$refs.resume && this.$refs.resume.clearFiles) this.$refs.resume.clearFiles();
      this.identityCardFrontUrl = "";
      this.identityCardFrontOtherParams = null;
      this.identityCardBackUrl = "";
      this.identityCardBackOtherParams = null;
      this.resumeUrl = "";
      this.resumeOtherParams = null;
      this.businessLicenseUrl = "";
      this.businessLicenseOtherParams = null;
    },
    /**
     * 查看大图
     */
    viewBigImage(url=""){
      this.viewImageUrl = url;
      this.visibleViewImage = true;
    },
  },
}
</script>

<style scoped lang="scss">
.real-name-title{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}

.identity-card-row{
  display: flex;
}
.row-space{
  margin-bottom: 40px;
}
.single-uploader{
  width: 194px;
  height: 168px;
  /deep/ .el-upload {
    &,
    .el-upload-dragger{
      width: 100%;
      height: 100%;
    }
    position: relative;
    overflow: hidden;
    .el-upload-dragger{
      &:not(:hover){
        border-color: #999;
      }
      &:hover {
        //border-color: #409EFF;
      }
    }
  }
  .single-uploader-image{
    width: 100%;
    height: 100%;
    display: block;
    border: none;
    object-fit: contain;
  }
  .single-uploader-icon{
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
}

.upload-inner-box{
  width: 100%;
  height: 100%;
  position: relative;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.tools-row{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  opacity: 0;
  background-color: rgba(0,0,0,.5);
  transition: opacity .3s;
  text-align: center;
  color: #fff;
  cursor: default;
  &:hover{
    opacity: 1;
  }
  .tools-item{
    cursor: pointer;
    font-size: 30px;
  }
}

.single-file{
  /deep/ .el-upload {
    width: 176px;
    height: 227px;
    .el-upload-dragger{
      width: 100%;
      height: 100%;
    }
    position: relative;
    overflow: hidden;
    .el-upload-dragger{
      border-radius: 10px;
      background: #F5F5F5;
      border: none;
      &:not(:hover){
        //border-color: #999;
      }
      &:hover {
        //border-color: #409EFF;
      }
    }
  }
  .single-file-icon{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon-image{
      display: block;
      width: 45px;
      height: 45px;
    }
    .description{
      margin-top: 18px;
      font-size: 10px;
      font-weight: 500;
      color: #666666;
      line-height: 18px;
    }
  }
  .single-file-image{
    width: 100%;
    height: 100%;
    display: block;
    border: none;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/realNameAuthentication/realNameAuthenticationPartner.vue